"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@xstate/react");
const useManageAppointmentContext_1 = require("../ManageAppointment/hooks/useManageAppointmentContext");
const States_1 = __importDefault(require("./lib/constants/States"));
const styles_1 = require("../components/LayoutFactory/styles");
const Shimmer_1 = __importDefault(require("../components/Loading/Provider/Shimmer"));
const ConfirmDOBPage_1 = __importDefault(require("./components/ConfirmDOBPage/ConfirmDOBPage"));
const react_2 = __importDefault(require("react"));
const ApptList_1 = __importDefault(require("./components/ApptTime/ApptList"));
const AppointmentWaitlistLayout_1 = __importDefault(require("./components/Layout/AppointmentWaitlistLayout"));
const AppointmentWaitlist = ({ service }) => {
    const [currentState] = (0, react_1.useService)(service);
    const { matches } = currentState;
    const { track } = (0, useManageAppointmentContext_1.useManageAppointmentContext)();
    if (matches(States_1.default.fetchingWaitlist)) {
        return (react_2.default.createElement(styles_1.SimpleContainer, null,
            react_2.default.createElement(Shimmer_1.default, null)));
    }
    const machine = matches(States_1.default.confirmDob)
        ? currentState.context.dobConfirmationMachine
        : service;
    return (react_2.default.createElement(AppointmentWaitlistLayout_1.default, { service: service, renderChildren: () => {
            if (matches(States_1.default.confirmDob)) {
                return (react_2.default.createElement(ConfirmDOBPage_1.default, { track: track, service: machine }));
            }
            if (matches(States_1.default.apptTime)) {
                return (react_2.default.createElement(ApptList_1.default, { service: currentState.context.apptTimeMachine }));
            }
            return null;
        } }));
};
exports.default = AppointmentWaitlist;
//# sourceMappingURL=AppointmentWaitlist.js.map